module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-scene"
  }, [_vm._m(0), _c('section', {
    staticClass: "mainsection hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-1"
  }, [_c('div', {
    staticClass: "box",
    class: {
      'is-shaking': _vm.hasError
    }
  }, [_c('form', {
    attrs: {
      "novalidate": "novalidate",
      "autocomplete": "on"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.requestAuth({
          email: _vm.email,
          password: _vm.password
        })
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Courriel")]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.hasError
    },
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": "courriel@exemple.com"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('label', {
    staticClass: "label"
  }, [_vm._v("Mot de passe")]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.hasError
    },
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "●●●●●●●"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _c('hr'), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    staticClass: "subtitle is-6 is-danger"
  }, [_vm._v("Identifiants invalides.")]), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isLoading, 'is-danger': _vm.hasError
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(!_vm.hasError ? 'Connexion' : 'Réessayer'))])])])]), _c('p', {
    staticClass: "has-text-centered"
  })]), _vm._m(2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "_margin-icon",
    attrs: {
      "src": require("@/assets/logo-noir.svg"),
      "width": "90px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-11 is-offset-1"
  }, [_c('h1', {
    staticClass: "bigtitle title is-1"
  }, [_c('b', [_vm._v("Robert veut lire")])]), _c('h2', {
    staticClass: "subtitle is-3"
  }, [_vm._v("Client")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-5 is-offset-1"
  }, [_c('div', {
    staticClass: "content infos"
  }, [_c('p', [_vm._v("Pour obtenir les suggestions gratuites de Robert veut lire, vous devez avoir un compte.")]), _c('p', [_vm._v("Vous pouvez nous le demander en nous écrivant à "), _c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "mailto:ici@robertveutlire.com"
    }
  }, [_vm._v("ici@robertveutlire.com")]), _vm._v(" ou simplement vous connecter avec l’identifiant suivant:")]), _c('table', {
    staticClass: "is-outline"
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Courriel")])]), _c('td', [_vm._v("jeteste@robertveutlire.com")])]), _c('tr', [_c('td', [_c('b', [_vm._v("Mot de passe")])]), _c('td', [_vm._v("jaimerobert")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbe12c26"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login-scene.vue
// module id = 1371
// module chunks = 1